import client from "../api/client";
export const getList = () => {
  return client('/api/contacts').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/contacts/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/contacts/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/contacts', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/contacts/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useContactService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
